module.exports = "//static.hsappstatic.net/salesImages/static-1.403/reporting/reporting-addon-spacesword.png"